import { PolicyVersion } from './PolicyVersion.js';

export class ConsentAPI {
  constructor({ config, bus, storage }) {
    this.config = config;
    this.bus = bus;
    this.storage = storage;
    this.state = this._initState();
  }

  _initState() {
    const stored = this.storage.read();
    if (stored && !PolicyVersion.needsReprompt(stored.v, this.config.policyVersion)) {
      this._uuid = stored.uuid;
      return this._statefromList(stored.purposes);
    }
    return this._statefromList(['functional']);
  }

  _statefromList(list) {
    const all = this.config.activePurposes;
    const set = new Set(list);
    const out = {};
    for (const p of all) {
      let granted = set.has(p) || p === 'functional';
      if (granted && p === 'marketing' && this._gpcActive()) granted = false;
      out[p] = granted;
    }
    return out;
  }

  _gpcActive() {
    return !!this.config.gpcEnabled && typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
  }

  get(purpose) { return !!this.state[purpose]; }
  all() { return { ...this.state }; }

  set(next) {
    this.state = this._statefromList(
      Object.entries(next).filter(([, v]) => v).map(([k]) => k)
    );
    this._uuid = this._uuid ?? (crypto.randomUUID?.() ?? this._fallbackUuid());
    this.storage.write({
      v: this.config.policyVersion,
      purposes: Object.entries(this.state).filter(([, v]) => v).map(([k]) => k),
      ts: Date.now(),
      uuid: this._uuid,
    });
    this.bus.emit('change', this.all());
  }

  revoke() {
    // Capture the uuid BEFORE clearing so listeners can record the revocation
    // against the same identifier the previous accept used.
    const revokedUuid = this._uuid;
    this.storage.clear();
    this._uuid = null;
    this.state = this._statefromList(['functional']);
    if (revokedUuid) {
      this.bus.emit('revoke', revokedUuid);
    }
    this.bus.emit('change', this.all());
  }

  uuid() { return this._uuid; }

  _fallbackUuid() {
    const r = (n) => Math.floor(Math.random() * n).toString(16);
    return `${r(0x100000000).padStart(8, '0')}-${r(0x10000).padStart(4, '0')}-4${r(0x1000).padStart(3, '0')}-8${r(0x1000).padStart(3, '0')}-${r(0x1000000000000).padStart(12, '0')}`;
  }
}
